// @flow
import React from 'react';
import MarkDown from 'brastrap/editorial/markdown/Markdown.jsx';
import Image from 'brastrap/common/image/Image';
import type { Welcome as Props } from './welcome.types.js';

const Welcome = (props: Props) => (
  <div className="c-welcome">
    <div className="c-welcome__body">
      {props.title && (
        <h1 className="c-welcome__title">
          <span className="u-text-style-handwritten">{props.title}</span>
        </h1>
      )}
      <div className="c-welcome__main">
        {props.main && (
          <div className="s-prose">
            <MarkDown content={props.main} />
          </div>
        )}
        <div className="c-welcome__images">
          {props.images.map(image => (
            <Image
              className="c-welcome__image"
              src={image.src}
              alt={image.alt}
            />
          ))}
        </div>
        {props.name && (
          <h1 className="c-welcome__name">
            <span className="s-prose">{props.name}</span>
          </h1>
        )}
      </div>
    </div>
  </div>
);

Welcome.defaultProps = {
  images: [],
};

export default Welcome;
